<script setup lang="ts">
import { ref } from 'vue';
import { type CommentSummaryDto } from '@/services/types/api.types';
import CommentSummaryEntry from './CommentSummaryEntry.vue';

const emit = defineEmits<{
  (e: 'save', id: number, text: string): void;
}>();

const entry = ref<CommentSummaryDto>({ id: -1, text: '' });
const state = ref<'button' | 'editor'>('button');

function reset() {
  entry.value = { id: -1, text: '' };
  state.value = 'button';
}

const onAdd = () => {
  state.value = 'editor';
};

const handleCancelEdit = () => {
  reset();
};

const handleSave = (id: number, text: string) => {
  console.log('handleSave', text);
  emit('save', id, text);
  reset();
};
</script>

<template>
  <comment-summary-entry v-if="state === 'editor'" :entry="entry" @cancelEdit="handleCancelEdit" @save="handleSave" />
  <q-btn
    v-if="state === 'button'"
    dense
    rounded
    size="sm"
    class="q-my-sm"
    icon="add"
    color="accent"
    @click.stop="onAdd"
  />
</template>
